import request from '@utils/xhttp'

// 新业务对象分组
export function getNewObjectGroup() {
    return request.get('/api_v3/studio/business-object/group')
}
// 新增业务对象分组
export function addNewObjectGroup(params) {
    return request.post('/api_v3/studio/business-object/group', params)
}
// 编辑业务对象分组
export function editNewObjectGroup(groupId, params) {
    return request.put(`/api_v3/studio/business-object/group/${groupId}`, params)
}
// 删除业务对象分组
export function delNewObjectGroup(groupId) {
    return request.delete(`/api_v3/studio/business-object/group/${groupId}`)
}

// 新业务对象列表
export function getNewObject(params) {
    return request.get('/api_v3/studio/objects', { params })
}

// 分组业务对象列表
export function getBusinessObject(params) {
    return request.get('/api_v3/studio/business-object/list', { params })
}

// 新业务对象列表
export function getNewSystemObject(params) {
    return request.get('/api_v3/studio/system-objects/list', { params })
}

// 新增业务对象
export function addNewObject(params) {
    return request.post('/api_v3/studio/business-object', params)
}
// 编辑业务对象
export function editNewObject(objectId, params) {
    return request.put(`/api_v3/studio/business-object/${objectId}`, params)
}
// 删除业务对象
export function delNewObject(objectId) {
    return request.delete(`/api_v3/studio/business-object/${objectId}`)
}
// 批量创建对象
export function batchCreateObject(data) {
    return request.post('/api_v3/studio/business-object/batch-cascade', data)
}

// 获取对象字段
export function getObjectField({ objectId }) {
    return request.get(`/api_v3/studio/objects/${objectId}`)
}

// 查询业务对象详情
export function getNewObjectDtl(objectId) {
    return request.get(`/api_v3/studio/objects/${objectId}`)
}

// 新业务对象字段列表
export function getNewObjectField(objectId) {
    return request.get(`/api_v3/studio/objects/${objectId}`)
}

// 新系统对象字段列表
export function getSystemObjectField({ objectId }) {
    return request.get(`/api_v3/studio/system-objects/${objectId}`)
}

// 新增业务对象字段
export function addNewObjectField(objectId, params) {
    return request.post(`/api_v3/studio/business-object/${objectId}/field`, params)
}
// 编辑业务对象字段
export function editNewObjectField(objectId, fieldId, params) {
    return request.put(`/api_v3/studio/business-object/${objectId}/field/${fieldId}`, params)
}
// 删除业务对象字段
export function delNewObjectField(objectId, fieldId) {
    return request.delete(`/api_v3/studio/business-object/${objectId}/field/${fieldId}`)
}
// 校验字段是否被占用
export function checkCustomizeField(appId, params) {
    const { workspaceId } = params
    return request.post(`/api/console-proxy/app/${appId}/workspace/${workspaceId}/check-customize-field`, params)
}
// 产品应用获取权限方案
export function getPurviewObject(params) {
    return request.post('/api/console-proxy/tenant/get-object-purview', params)
}

// 新服务分组
export function getNewServiceGroup() {
    return request.get('/api_v3/studio/service-group')
}
// 新增服务分组
export function addNewServiceGroup(params) {
    return request.post('/api_v3/studio/service-group', params)
}
// 编辑服务分组
export function editNewServiceGroup(groupId, params) {
    return request.put(`/api_v3/studio/service-group/${groupId}`, params)
}
// 删除服务分组
export function delNewServiceGroup(groupId) {
    return request.delete(`/api_v3/studio/service-group/${groupId}`)
}

// 新服务列表
export function getNewService(params) {
    return request.get('/api_v3/studio/service', { params })
}
// 新增服务
export function addNewService(params) {
    return request.post('/api_v3/studio/service', params)
}
// 编辑服务
export function editNewService(serviceId, params) {
    return request.put(`/api_v3/studio/service/${serviceId}`, params)
}
// 删除服务
export function delNewService(serviceId) {
    return request.delete(`/api_v3/studio/service/${serviceId}`)
}

export function closeMock() {
    return request.post('/api_v3/studio/service/close-mock')
}

/**
 * * 获取业务对象详情
 * @param webappId
 * @param id
 */
export function getObjectDetail({ id }) {
    return request.get(`/api_v3/studio/objects/${id}`)
}

// 导入对象
export function importObject(webappId, params, workspaceId) {
    return request.post(`/api/console-proxy/app/${webappId}/workspace/${workspaceId}/import-object`, params)
}

// 导入服务
export function importService(webappId, params, workspaceId) {
    return request.post(`/api/console-proxy/app/${webappId}/workspace/${workspaceId}/import-service`, params)
}
/**
 * 获取全部业务环境列表
 */
export function getEnvList(params) {
    return request.get('/api_v3/studio/business-env/category-list', { params })
}

// 服务编排
// 获取编排分组
export function getServiceArrangeGroup(appId, workspaceId, params) {
    return request.get(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/group-list`, { params })
}
// 新增编排分组
export function addServiceArrangeGroup(appId, workspaceId, params) {
    return request.post(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/group-add`, params)
}
// 编辑编排分组
export function editServiceArrangeGroup(appId, params, workspaceId) {
    return request.post(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/group-edit`, params)
}

// 获取编排服务
export function getServiceArrange(appId, params, workspaceId) {
    return request.get(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/list`, { params })
}
// 新增编排服务
export function addServiceArrange(appId, params, workspaceId) {
    return request.post(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/add`, params)
}
// 编辑编排服务
export function editServiceArrange(appId, params, workspaceId) {
    return request.post(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/modify`, params)
}
// 删除编排服务
export function delServiceArrange(appId, workspaceId, params) {
    return request.post(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/delete`, params)
}
// 发布服务编排
export function publishServiceArrange(appId, workspaceId, params) {
    return request.post(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/run`, params)
}
// 下线服务编排
export function offlineServiceArrange(appId, workspaceId, params) {
    return request.post(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/stop`, params)
}
// 单点登录服务编排
export function loginServiceArrange(appId, workspaceId, params) {
    return request.get(`/api_v3/developer/app/${appId}/workspace/${workspaceId}/flow/sso`, { params })
}
// 演示数据：获取演示数据表格列表
export function getMockList(params) {
    return request.get('/api_v3/studio/mock/object/list', { params })
}
// 演示数据：下载模板
export function getMockTemplate(params) {
    return request.get('/api_v3/studio/mock/object/data-template', { params }, { responseType: 'blob' })
}
// 演示数据：删除一项演示数据
export function deleteMockItem(mockId) {
    return request.delete(`/api_v3/studio/mock/object/${mockId}/data-delete`)
}
// 演示数据：创建业务对象
export function createMockObject(params) {
    return request.post('/api_v3/studio/mock/object', params)
}
// 演示数据：上传 excell
export function uploadMockExcell(params) {
    return request.post('/api_v3/studio/mock/object/preview', params)
}
// 演示数据：更新演示数据 excell
export function updateMockExcell(params) {
    const { objectId } = params
    delete params.objectId
    return request.put(`/api_v3/studio/mock/object/${objectId}/data-refresh`, params)
}
